<template src="./Tasks.html"></template>

<script>
    import translationsTopMenu from "@/components/translations/components/topMenu";
    import Pagination from "@/components/components/pagination";
    import { createNamespacedHelpers } from 'vuex';

    const { mapGetters, mapActions} = createNamespacedHelpers('translations/tasks')

    export default {
        name: "Task",
        components: {
            translationsTopMenu,
            Pagination
        },
        data () {
            return {
                showOverlay: false,
              fieldsList: [
                {
                  key: 'id',
                  label: 'ID'
                },
                {
                  key: 'sourceField',
                  label: 'Источник'
                },
                {
                  key: 'targetField',
                  label: 'Назначение'
                },
                {
                  key: 'createdTime',
                  label: 'Время создания'
                },
                {
                  key: 'completed',
                  label: 'Завершено'
                },

              ]
            }
        },
        methods: {
            ...mapActions([
                'GET_DATA'
            ]),
          goToPage: function (page) {
            this.$store.commit('translations/tasks/CURRENT_PAGE', page);
            this.GET_DATA({th: this});
          },
          perPage: function (page) {
            this.$store.commit('translations/tasks/PER_PAGE', page);
            this.GET_DATA({th: this});
          },
          initPageSize: function () {
            let winHeight = window.innerHeight;
            winHeight = Math.round((winHeight - 195) / 25);
            this.$store.commit('translations/tasks/PER_PAGE', winHeight);
            this.$store.commit('translations/tasks/CURRENT_PAGE', 1);
          },
        },
        computed: {
            ...mapGetters([
                'TASK_DATA',
                'CURRENT_PAGE',
                'AMOUNT_PAGE',
                'PER_PAGE',
                'TOTAL_ROWS',
            ]),

        },
        mounted() {
          if (this.$store.getters.getAllowSection.indexOf('translations') === -1) {
            this.$router.push({name: 'permissionDenied'});
            return;
          }
        },
        created() {
          this.initPageSize();
          this.GET_DATA({th: this});
        }
    }
</script>

<style scoped>

</style>

<style>

</style>